export const getUser = state => state.useraccount.user;
export const isActivated = state => state.useraccount.activated;